import * as types from './mutation_types';

export const addModule = ({ commit }, data) => commit(types.ADD_MODULE, data);
